import { useAppSelector } from '../../store/hooks';
import { Language } from '../../rest/models';
import { LanguageListRow } from './LanguageListRow';
import { LanguageEditForm } from './LanguageEditForm';
import { getModelMap } from '../../rest/slice';
import { GetPageTitle } from '../../ErnotsConfig';
import { LanguageExplanations } from './explanation';
import { InfoTrigger } from '../info_popup/InfoTrigger';
import { canEdit } from '../../rest/data';
import { DictRequestStatusDisplay, PleaseWait } from '../CommonComponents';

export function LanguageList()
{
    const loginState = useAppSelector((state) => state.login);
    const langModels = getModelMap(useAppSelector, Language);
    const hasData = langModels != null;

    let table = <>
        <PleaseWait what='the language table'/>
        <DictRequestStatusDisplay modelClass={Language} />
    </>;

    if (hasData)
    {
        const langsModels2 = Object.values(langModels);
        langsModels2.sort((a, b) => a.name.localeCompare(b.name));
        
        const _public = langsModels2
            .filter(l => l.public)
            .map(l => `${l.name} (${l.gtrans_code}); `);

        const public2 = _public.length
            ? <fieldset>
                <b>Public languages (and their Google Translate codes):</b>
                <InfoTrigger children={LanguageExplanations.publicObject}/>

                <div>{_public}</div>
            </fieldset>
            : <></>;

        const italicsNote = loginState.currentUser.is_staff
            ? <div><i>For administrators: Rows in italics are public.</i></div>
            : <></>;

        const editableTableRows = langsModels2
            .filter(l => canEdit(l, loginState))
            .map(l => <LanguageListRow key={l.key} lang={l}/>);
    
    
        table = (
        <div>
            {italicsNote}
            <table className='ernots_ModelTable ernots_LanguageTable' border={1}>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>
                            Google Translate code
                            <InfoTrigger children={LanguageExplanations.googleTranslateCode}/>
                        </th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {editableTableRows}
                </tbody>
            </table>
            {public2}
        </div>)
    }

    return (
    <div className='ernots_ModelEditor ernots_LanguageEditor'>
        <title>{GetPageTitle('Languages')}</title>
        {LanguageExplanations.header}
        <LanguageEditForm  onDone={() => {}}/>
        <br/>
        {table}
    </div>);
}